import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';
import {Auth, API} from 'aws-amplify';

import {Redirect } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import NearMeIcon from '@material-ui/icons/NearMe';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import CircularProgress from '@material-ui/core/CircularProgress';
import CarLogo from './CarLogo';
import Divider from '@material-ui/core/Divider';
import { removeDollarSign, validateEmail } from '../helper';
import RatingStars from './RatingStars';
import ReactGA from 'react-ga';
import Footer from './Footer';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';


import DealTiles from './dashboard/DealTiles';


const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  card: {
    //maxWidth: 300,
  },
  media: {
    height: 0,
    paddingTop: '46.25%', // 16:9
    // 'max-width': 160,
    // 'max-height': 100,
    // height: '600',
    // width: 'auto',
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },

  infoCardCenter: {
    display: 'flex',
    justifyContent: 'center'
  },
  infoCard: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  ratingDetails: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  additionalDetails: {
    display: 'flex',
    flexDirection: 'column',
    //marginLeft: '20',
    marginLeft: theme.spacing.unit*3,
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  // title: {
  //   color: theme.palette.primary.light,
  // },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  pos: {
    marginBottom: 12,
  },
  infoIcon: {
    marginLeft: 16,
  },
  largeIcon: {
    width: 40,
    height: 40,
  },
  content: {
    //backgroundColor: theme.palette.background.default,
    width: '100%',
    //padding: theme.spacing.unit * 3,
    height: 'calc(100% - 16px)',
    marginTop: 24,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 24px)',
      marginTop: 40,
      //marginLeft: -20,
    },
    overflow: 'auto'
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    // justifyContent: 'flex-start',
    alignItems: 'center',
    // //paddingLeft: '5px',
    // //paddingTop: 36,
    // //marginTop: -4,
    // [theme.breakpoints.up('sm')]: {
    //   //height: 'calc(100% - 24px)',
    //   //marginTop: 40,
    //   //marginLeft: -20,
    //},
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
  progress: {
    //[theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing.unit*12,
    //},
    // marginBottom: 36,
    // marginLeft: 12,
    // margin: '0 auto',
    // width: '50%',
  },
  margin_left: {
    margin: theme.spacing.unit*3,
  },
  carImage: {
    display: 'flex',
    // 'max-width': 260,
    // 'max-height': 180,
    // 'max-width': 160,
    // 'max-height': 100,
    //height: 'auto',
    height: '32vh',
    'object-fit': 'contain',
    //'max-width': '90%',
    justifyContent: 'center',
    //margin: '20',
  },
  carImageDiv: {
    position: 'relative',
    display: "flex",
    flexDirection: "column",
    width: '100%',
    justifyContent: "space-between",
  },
  button: {
    margin: theme.spacing.unit,
  },
  interestedButton: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
        //you want this to be the same as the backgroundColor above
        backgroundColor: theme.palette.primary.main,
    },
  },
  chip: {
    position: 'absolute',
    margin: theme.spacing.unit,
    zIndex: 2,
    right: -2,
    top: 2,
    backgroundColor: theme.palette.primary.light,
  },
  location: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit*3,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
});


class DealDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      deal: '',
      expanded: false,
      redirectToLogin: false,
      cognitoUser: '',
      favoriteDeals: [],
      isFavorite: false,
      isInterestedDialogOpen: false,
      txtName: '',
      txtEmail: '',
      txtPhone: '',
      selectReason: '',
      dealId: props.match.params.id,
      similarDeals: [],
    };

    this.fetchDealsDetail(props.match.params.id)
  }

  imgError = (event) => {
    event.target.src = "http://hipkar.com.s3.amazonaws.com/images/placeholder.png";
    //console.log('img could not be loaded');
  };

  handleInterestedClose = () => {
    this.setState({
      isInterestedDialogOpen: false,
    });
    if (!validateEmail(this.state.txtEmail))
      console.log('email validaiton failed');
    else
      this.saveNewLead();
  }

  handleInterestedCancel = () => {
    this.setState({
      isInterestedDialogOpen: false,
    });
  }

  handleInterestedOpen = () => {
    this.setState({
      isInterestedDialogOpen: true,
    });

  }

  handleInterestedTextChange = name => (event) => {
    this.setState({
      [name]: event.target.value
    });

  }

  handleExpandClick = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  componentWillMount() {
    ReactGA.initialize('UA-107081605-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  //this gets fired when the allLocalDeals are already populated (when user navigates from the filteredDeals component)
  componentDidMount() {
    if (this.props.allLocalDeals != null) {
      //console.log('componendDidMount local deals: ', this.props.allLocalDeals);
      this.setState({
        similarDeals: this.findSimilarDeals(this.props.allLocalDeals),
      });
    }
  }

  //this is for direct access to this page
  componentDidUpdate(prevProps, prevState, snapshot) {
    
    const { allLocalDeals } = this.props;

    if (allLocalDeals !== prevProps.allLocalDeals ) {
      //console.log('props changed...');
      this.setState({
        similarDeals: this.findSimilarDeals(allLocalDeals),
      });
      //console.log('all local deals: ', this.props.allLocalDeals);
    }

    if (this.props.match.params.id !== prevProps.match.params.id) {
      //console.log('id in params changed...');
      //no need to go back to the server
      //this.fetchDealsDetail(this.props.match.params.id);
      const currentDeal = allLocalDeals.filter(d => { return d.id === this.props.match.params.id });
      if(currentDeal.length > 0) {
        this.setState({
          deal: currentDeal[0],
        }, () => {
          this.setState({
            similarDeals: this.findSimilarDeals(allLocalDeals),
          });
          window.scrollTo(0, 0);
        });
      }
    } 

  }

  shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
  }

  findSimilarDeals(allLocalDeals) {
    const MAX_SIMILAR_DEALS = 5;
    this.shuffle(allLocalDeals);
    const currentDeal = allLocalDeals.filter(d => { return d.id === this.props.match.params.id });
    //console.log('currentDeal: ' + JSON.stringify(currentDeal[0]));
    if (currentDeal.length > 0) {
      if (currentDeal[0].tags) {
        var similarDeals = allLocalDeals.filter(d => {
          if (d.tags.length > 0)
            return JSON.stringify(currentDeal[0].tags) === JSON.stringify(d.tags);
        });
        //console.log('similarDeals length: ' + similarDeals.length);

        if (similarDeals.length > MAX_SIMILAR_DEALS) {
          similarDeals = similarDeals.slice(0,MAX_SIMILAR_DEALS);        
        } else if (similarDeals.length < MAX_SIMILAR_DEALS) {
          const diff = (MAX_SIMILAR_DEALS-similarDeals.length);
          for (var i=0;i < diff;i++) {
            similarDeals.push(allLocalDeals[Math.floor(Math.random()*allLocalDeals.length)]);
          }
        } 
        //add one random similar to mix it up
        similarDeals.push(allLocalDeals[Math.floor(Math.random()*allLocalDeals.length)]);
        return similarDeals;         
      } 
    }
  }

  //get all deals by car make
  saveNewLead = async () => {
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'name': this.state.txtName,
            'email': this.state.txtEmail,
            'phone': this.state.txtPhone,
            'dealId': 'https://hipkar.com/explore/deals/detail/' + this.state.dealId,
            'reason': this.state.selectReason,
            'userZip': sessionStorage.getItem('zip'),
        }
    }

    API.post('leasy','/add-new-lead', requestParams)
        .then(data => {
          this.setState({
            snackbarOpen: true
          });
          ReactGA.event({
            category: 'User',
            action: 'New Lead',
            value: 1
          });
          //console.log('now sending conversion to adwords');

        })
        .catch (err => console.log(err))
  }

  fetchDealsDetail = async (id) => {
    //console.log('in fetchDealsDetail');
    let requestParams = {
        headers: {'content-type': 'application/json'},
        body : {
            'id': id
        }
    }

    API.post('leasy','/deals', requestParams)
        .then(data => {
          //console.log(data);
          this.setState({
              deal: data[0]
          });
          //return data;
          let checkIfLoggedIn = localStorage.getItem('isLoggedIn');
          if (checkIfLoggedIn === 'true') {
            //console.log('checkIfLoggedIn is true indeed!');
            this.getCognitoUserSession();
          }
        })
        .catch (err => console.log(err))
  }

  formatDate(d) {
    let date = new Date(d);
    //console.log('date: ' + date);
    return (date.getMonth()+1) + '/' + date.getDate() + '/' + date.getFullYear();
  }

  formatTresCommas(val) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  calculateMilesPerYear () {
    const { deal } = this.state;

    let total_miles_allowed = parseInt(deal.totalMilesAllowed.replace(/,/g, ''), 10);
    let lease_months = parseInt(deal.leaseMonths, 10);
    return this.formatTresCommas(Math.round(total_miles_allowed / (lease_months/12)))
  }

  calculateOfferValue() {
    const { deal } = this.state;
    if (deal.valueScore < 90)
      return 'Exceptional!';
    else if (deal.valueScore < 100)
      return 'Great';
    else if (deal.valueScore < 110)
      return 'Good';
    else if (deal.valueScore < 120)
      return 'Average';
    else if (deal.valueScore < 130)
      return 'Bad';
    else if (deal.valueScore < 140)
      return 'Really Bad';
    else
      return 'Stay Away!';
  }

  handleBackClick = () => {
    //console.log('back clicked');
    //this.props.history.goBack()
    this.props.history.push('/');
  }

  handleFavoriteClick = () => {
    let favoriteDealIDs = [];

    let checkIfLoggedIn = localStorage.getItem('isLoggedIn');
    //console.log('checkIfLoggedIn: ' + checkIfLoggedIn);
    if (checkIfLoggedIn === 'true') {
      if ('custom:favoriteDeals' in this.state.cognitoUser.attributes) {
        favoriteDealIDs = this.state.cognitoUser.attributes['custom:favoriteDeals'].split(",")
      } else {
        favoriteDealIDs = [];
      }

      if (this.state.isFavorite) {
        // console.log('current deal id: ' + this.state.deal.id);
        // console.log('old favoriteDealIDs: ' + favoriteDealIDs);
        for(var i=0;i<favoriteDealIDs.length;i++) {
          if (favoriteDealIDs[i] === this.state.deal.id) {
            favoriteDealIDs.splice(i,1);
            //console.log('new favoriteDealIDs: ' + favoriteDealIDs);
          }
        }
        this.setState({
            isFavorite: false
        });
      } else { //not currently a favorite
        favoriteDealIDs.push(this.state.deal.id);
        this.setState({
            isFavorite: true
        });
      }
      let _deals = this.convertToCSVString(favoriteDealIDs);
      this.insertFavDeals(_deals);
    } else {
      this.setState({
          redirectToLogin: true
      });
    }
  }

  convertToCSVString(favoriteDealIDs) {
    let _deals = '';
    for(var i=0;i<favoriteDealIDs.length;i++) {
      if (_deals === '') {
        _deals = favoriteDealIDs[i];
      } else {
        _deals = _deals + "," + favoriteDealIDs[i];
      }
    }
    //console.log('after convertToCSVString: ' + _deals);
    return _deals;
  }

  insertFavDeals = (_deals) => {
    //console.log('in insertFavDeals');
    //let _deals = "a98ccc63-36ca-40bd-a544-2a5c112e2f1b,4e9d6202-126e-4560-a5b3-a53051ee4a89";
    try {
      Auth.updateUserAttributes(this.state.cognitoUser, {
          "custom:favoriteDeals": _deals
      });
    } catch (err) {
      console.log('error updating user info: ', err);
    }
  }

  //get the logged-in user session
  getCognitoUserSession = async () => {
    //console.log('now in getCognitoUserSession()');
    try {
      Auth.currentAuthenticatedUser()
        .then(data => {
          //console.log(data);
          this.setState({
              cognitoUser: data,
          });
          //console.log('cognitoUser set.');
          let favoriteDealIDs = [];
          if ('custom:favoriteDeals' in data.attributes) {
            favoriteDealIDs = data.attributes['custom:favoriteDeals'].split(",");
          }
          for(var i=0;i<favoriteDealIDs.length;i++) {
            if (favoriteDealIDs[i] === this.state.deal.id) {
              //console.log('setting to isFavorite');
              this.setState({
                  isFavorite: true
              });
            }
          }
        })
    } catch (err) {
      console.log('error fetching user info: ', err);
    }
  }

  handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({
      snackbarOpen: false
    });
  }

  render() {
    const { classes, leasyZip } = this.props;
    const { deal, redirectToLogin, isFavorite, isInterestedDialogOpen, txtName, txtEmail, txtPhone, snackbarOpen, selectReason, similarDeals } = this.state;

    const nameError = (txtName.length < 2) ? true : false;
    const emailError = (!validateEmail(txtEmail)) ? true : false;
    const submitDisabled = (nameError && emailError) ? true : false;
    const leaseEndPurchase = (deal.leaseEndPurchase) ? this.formatTresCommas(removeDollarSign(deal.leaseEndPurchase)) : "-";

    if (redirectToLogin) {
      return <Redirect to='/login'/>
    } else {

    return (
        (deal) ?
        <Grid container alignItems="stretch" justify="center" spacing={8}>
          <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8}>
            <div className={classes.content}>


                <Paper className={classes.detailHeader}>
                  <IconButton className={classes.contrastText} aria-label="Menu" onClick={this.handleBackClick}>
                    <NavigateBeforeIcon />
                  </IconButton>
                  <CarLogo brand={deal.make}/>
                  <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                    {deal.model}
                  </Typography>
                </Paper>

                {/* <Paper elevation={0}> */}
                <Grid container alignItems="stretch" justify="center" spacing={8}>
                      <Grid item xs={12} sm={12}>
                        
                          <div className={classes.carImageDiv}>
                            {deal.localOffer && (deal.localOffer === "True") ?
                            <Chip label="Local Special" className={classes.chip} />
                            : ''}
                            { (deal.offerImage) ?
                              <img src={deal.offerImage} onError={this.imgError} className={classes.carImage} alt="" />
                              :
                              <img src="http://hipkar.com.s3.amazonaws.com/images/placeholder.png" className={classes.carImage} alt="" />
                            }

                          </div>
                          <Grid container alignItems="baseline" justify="space-between" spacing={8}>
                            <Grid item>
                              {deal.localOffer && (deal.dealerCity.length > 0) ?
                                <Typography color="textSecondary" className={classes.location}>
                                  {deal.dealerCity + ", " + deal.dealerState}
                                </Typography>
                                : <Button onClick={this.handleFavoriteClick} variant="flat" color="primary" className={classes.button}>
                                  { isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon/> }
                                </Button>
                              }

                            </Grid>
                            <Grid item>
                              <Button size="small" onClick={this.handleInterestedOpen} variant="outlined" className={classes.interestedButton}>
                                GET THIS DEAL
                              </Button>
                              <Dialog open={isInterestedDialogOpen} onClose={this.handleInterestedClose} aria-labelledby="form-dialog-title">
                                <DialogTitle id="form-dialog-title">Tell us more...</DialogTitle>
                                <DialogContent>
                                  <DialogContentText>
                                    so we can help you get this awesome lease deal
                                  </DialogContentText>
                                  <FormControl className={classes.formControl}>
                                  <TextField
                                    error={nameError}
                                    id="txtName"
                                    label="Full Name"
                                    className={classes.textField}
                                    value={txtName}
                                    onChange={this.handleInterestedTextChange('txtName')}
                                    margin="normal"
                                    fullWidth
                                  />
                                  </FormControl>
                                  <FormControl className={classes.formControl}>
                                  <TextField
                                    error={emailError}
                                    id="txtEmail"
                                    label="Email"
                                    className={classes.textField}
                                    value={txtEmail}
                                    onChange={this.handleInterestedTextChange('txtEmail')}
                                    margin="normal"
                                    fullWidth
                                  />
                                  </FormControl>
                                  <FormControl className={classes.formControl}>
                                  <TextField
                                    id="txtPhone"
                                    label="Phone (optional)"
                                    className={classes.textField}
                                    value={txtPhone}
                                    onChange={this.handleInterestedTextChange('txtPhone')}
                                    margin="normal"
                                    fullWidth
                                  />
                                  </FormControl>
                                  <FormControl className={classes.formControl}>
                                    <InputLabel htmlFor="select-reason">
                                      Reason
                                    </InputLabel>
                                    <Select
                                      value={selectReason}
                                      onChange={this.handleInterestedTextChange('selectReason')}
                                      inputProps={{
                                        name: 'selectReason',
                                        id: 'select-reason',
                                      }}
                                    >
                                      <MenuItem value="">
                                        <em>None</em>
                                      </MenuItem>
                                      <MenuItem value={"valInterested"}>I'm interested in this deal</MenuItem>
                                      <MenuItem value={"valTestDrive"}>I would like to test drive this car</MenuItem>
                                      <MenuItem value={"valExploreOptions"}>I want explore lease options for this car</MenuItem>

                                    </Select>
                                  </FormControl>
                                </DialogContent>
                                <DialogActions>
                                  <Button onClick={this.handleInterestedCancel} color="primary">
                                    Cancel
                                  </Button>
                                  <Button disabled={submitDisabled} onClick={this.handleInterestedClose} color="primary">
                                    Submit
                                  </Button>
                                </DialogActions>

                              </Dialog>
                            </Grid>
                          </Grid>
                        
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <div className={classes.infoCardCenter}>

                          <div className={classes.ratingDetails}>
                              <RatingStars valueScore={deal.valueScore} />
                              <Typography color="textSecondary">
                                LEASE OFFER RATING
                              </Typography>

                          </div>
                        </div>
                      </Grid>


                      <Grid item xs={6} sm={3}>
                        <div className={classes.infoCard}>
                          <IconButton className={classes.infoIcon} aria-label="Add to favorites">
                            <MonetizationOnIcon className={classes.largeIcon} />
                          </IconButton>
                          <div className={classes.details}>

                              <Typography variant="headline" component="h2">
                                ${removeDollarSign(deal.leaseMonthlyPayment)}
                              </Typography>
                              <Typography color="textSecondary">
                                /MONTH
                              </Typography>

                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={6} sm={3}>
                        <div className={classes.infoCard}>
                          <IconButton className={classes.infoIcon} aria-label="Add to favorites">
                            <WatchLaterIcon className={classes.largeIcon} />
                          </IconButton>
                          <div className={classes.details}>

                              <Typography variant="headline" component="h2">
                                {deal.leaseMonths}
                              </Typography>
                              <Typography color="textSecondary">
                                MONTHS
                              </Typography>

                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={6} sm={3}>
                        <div className={classes.infoCard}>
                          <IconButton className={classes.infoIcon} aria-label="Add to favorites">
                            <AccountBalanceIcon className={classes.largeIcon} />
                          </IconButton>
                          <div className={classes.details}>

                              <Typography variant="headline" component="h2">
                                ${removeDollarSign(deal.dueAtSigning)}
                              </Typography>
                              <Typography color="textSecondary">
                                DUE AT SIGNING
                              </Typography>

                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={6} sm={3}>
                        <div className={classes.infoCard}>
                          <IconButton className={classes.infoIcon} aria-label="Add to favorites">
                            <DirectionsCarIcon className={classes.largeIcon} />
                          </IconButton>
                          <div className={classes.details}>

                              <Typography variant="headline" component="h2">
                                {this.calculateMilesPerYear()}
                              </Typography>
                              <Typography color="textSecondary">
                                MILES/YR
                              </Typography>

                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={12}><Divider /></Grid>

                      <Grid item xs={6} sm={3}>
                          <div className={classes.infoCard}>
                            <div className={classes.additionalDetails}>
                              <Typography color="textSecondary">
                                MSRP:
                              </Typography>
                                <Typography variant="body1" component="h2">
                                  ${this.formatTresCommas(removeDollarSign(deal.msrp))}
                              </Typography>
                            </div>
                          </div>
                      </Grid>


                      <Grid item xs={6} sm={3}>

                          <div className={classes.infoCard}>
                            <div className={classes.additionalDetails}>
                              <Typography color="textSecondary">
                                Offer Expires:
                              </Typography>
                              <Typography variant="body1" component="h2">
                                {this.formatDate(deal.leaseOfferExpiration)}
                              </Typography>

                            </div>
                          </div>
                      </Grid>

                      <Grid item xs={6} sm={3}>
                          <div className={classes.infoCard}>
                            <div className={classes.additionalDetails}>
                              <Typography color="textSecondary">
                                Excess Mile Charge:
                              </Typography>
                              <Typography variant="body1" component="h2">
                                {deal.excessMileCharge}
                              </Typography>
                            </div>

                          </div>

                      </Grid>

                      <Grid item xs={6} sm={3}>
                          <div className={classes.infoCard}>
                            <div className={classes.additionalDetails}>
                              <Typography color="textSecondary">
                                Lease-End Purchase:
                              </Typography>
                              <Typography variant="body1" component="h2">
                                { leaseEndPurchase }                                  
                              </Typography>

                            </div>
                          </div>
                      </Grid>

                    </Grid>
                    <Snackbar
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      open={snackbarOpen}
                      autoHideDuration={5000}
                      onClose={this.handleSnackbarClose}
                      ContentProps={{
                        'aria-describedby': 'message-id',
                      }}
                      message={<span id="message-id">Thank you! Someone will be in touch with you shortly.</span>}
                      action={[
                        <IconButton
                          key="close"
                          aria-label="close"
                          color="inherit"
                          className={classes.close}
                          onClick={this.handleSnackbarClose}
                        >
                          <CloseIcon />
                        </IconButton>,
                      ]}
                    />
                {/* </Paper> */}
                

            </div>

          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid>

          <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8}>
            <div>
            <Typography className={classes.margin_left} variant="headline" component="h5">
                People Also Viewed
            </Typography>
            </div>
            <DealTiles list={similarDeals} leasyZip={leasyZip}/>
          </Grid>
          <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid>

        </Grid>

        : 
        
        <Grid container direction="column" alignItems="center" justify="space-between" spacing={8}>
          {/* <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid> */}
          <Grid>
            <CircularProgress className={classes.progress} />
          </Grid>
          {/* <Grid item xs={0} sm={0} md={0} lg={2}>
          </Grid> */}
        </Grid>
    );
    }
  }

}

DealDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(DealDetail);



// WEBPACK FOOTER //
// ./src/components/DealDetail.jsx